import { useMemo } from "react";

/** Shared spacing/typography for configuration editors when shown in a compact shell (e.g. graph side panel). */
export function useEditorShellTokens(compact: boolean = false) {
  return useMemo(
    () => ({
      compact,
      label: {
        fontWeight: "700" as const,
        color: "gray.800",
        fontSize: (compact ? "xs" : "sm") as "xs" | "sm",
        mb: (compact ? 0.5 : 1) as number,
      },
      field: {
        bg: "white" as const,
        borderColor: "gray.200" as const,
        fontSize: (compact ? "xs" : "sm") as "xs" | "sm",
        _focus: {
          borderColor: "purple.600",
          boxShadow: "0 0 0 1px var(--chakra-colors-purple-600)",
          bg: "white",
        },
      },
      inputSize: (compact ? "sm" : "md") as "sm" | "md",
      sectionPx: compact ? 3 : 4,
      sectionPy: compact ? 1.5 : 2,
      sectionTitleSize: (compact ? "xs" : "sm") as "xs" | "sm",
      contentPx: compact ? 3 : 7,
      contentPt: compact ? 3 : 4,
      contentPb: compact ? 4 : 5,
      vStackSpacing: compact ? 3 : 5,
      propertiesInnerSpacing: compact ? 4 : 5,
      propertiesInnerInner: compact ? 5 : 6,
      radioText: (compact ? "xs" : "sm") as "xs" | "sm",
      textareaRows: compact ? 3 : 5,
      filterCollapsePy: compact ? 3 : 4,
      bodyText: (compact ? "xs" : "sm") as "xs" | "sm",
      panelHeading: (compact ? "md" : "lg") as "md" | "lg",
      iconBox: compact ? 3 : 3.5,
    }),
    [compact]
  );
}
